<template>
  <div>
    <!-- <c-card title="건강검진결과 엑셀업로드" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
          <c-btn 
            v-if="editable" 
            label="적용" 
            icon="save"
            @btnClicked="acceptData" />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-process
            required
            :editable="editable"
            label="공정"
            name="processCd"
            v-model="excelUploadInfo.processCd">
          </c-process>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-dept
            :editable="editable"
            label="부서"
            name="deptCd"
            v-model="excelUploadInfo.deptCd">
          </c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-text
            required
            :editable="editable"
            label="단위작업장소"
            name="workPlace"
            v-model="excelUploadInfo.workPlace">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <c-text
            :editable="editable"
            :disabled="true"
            label="요청부서/이름/일자"
            name="request"
            v-model="request">
          </c-text>
        </div>
      </template>
    </c-card> -->
    <c-excel-upload 
      :editable="editable"
      :excelUploadInfo="excelUploadInfo"
      tabHeight="660px"
      gridHeight="630px"
      :isAccept="true"
      @acceptData="acceptData"
    />
  </div>
</template>

<script>
export default {
  name: 'checkup-result-excel-upload',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          plantCd: '',
          examines: [],
        }
      },
    },
  },
  data() {
    return {
      excelUploadInfo: {
        rowKeys: ['heaCheckupResultId'], // 데이터들의 키 속성값
        taskClassCd: 'HEA_RESULT', // 엑셀업로드 양식 구분 값
        sheetNum: 0,
        columns: [[
          {
            name: 'checkTypeName',
            field: 'checkTypeName',
            disabled: true,
            label: '검진구분',
            align: 'center',
            style: 'width:100px',
          },
          {
            name: 'userName',
            field: 'userName',
            disabled: true,
            label: '성명',
            align: 'center',
            style: 'width:100px',
          },
          {
            required: true,
            name: 'regNo',
            field: 'regNo',
            disabled: true,
            label: '주민번호',
            align: 'center',
            style: 'width:130px',
          },
          {
            name: 'checkupDate',
            field: 'checkupDate',
            label: '검진일자',
            disabled: true,
            align: 'center',
            style: 'width:120px',
          },
          {
            name: 'hazardNames',
            field: 'hazardNames',
            label: '취급물질',
            disabled: true,
            style: 'width:400px', 
            align: 'left',
            sortable: false
          },
          {
            name: 'judgmentNames',
            field: 'judgmentNames',
            label: '특수판정',
            style: 'width:250px', 
            disabled: true,
            align: 'left',
            sortable: false
          },
          {
            name: 'diseaseNames',
            field: 'diseaseNames',
            label: '특수소견',
            style: 'width:500px', 
            disabled: true,
            align: 'left',
            sortable: false
          },
          {
            name: 'specialMeasures',
            field: 'specialMeasures',
            label: '특수조치',
            style: 'width:300px', 
            disabled: true,
            align: 'left',
            sortable: false
          },
          {
            name: 'specialSuitabilities',
            field: 'specialSuitabilities',
            label: '특수업무적합성',
            style: 'width:200px', 
            disabled: true,
            align: 'left',
            sortable: false
          },
          {
            name: 'remarks',
            field: 'remarks',
            label: '비고',
            style: 'width:200px', 
            disabled: true,
            align: 'left',
            sortable: false
          },
          // 검진항목
        ]],
        data: [],
        deptCd: '',
        processCd: '',
        workplace: '',
      },
      changeItem: {
        plant: '',
        process: '',
        vendor: '',
      },
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    request() {
      return this.$store.getters.user.deptName + ' / ' + this.$store.getters.user.userName + ' / '  + this.$comm.getToday()
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      if (this.popupParam.examines && this.popupParam.examines.length > 0) {
        this.excelUploadInfo.columns[0] = this.$_.concat(this.excelUploadInfo.columns[0], this.$_.map(this.popupParam.examines, examine => {
          return {
            name: examine.examineId,
            field: examine.examineId,
            label: examine.examineName,
            style: 'width:70px',
            disabled: true,
            align: 'center',
            sortable: false,
          }
        }))
      }
      // list setting
    },
    acceptData() {
      if (this.excelUploadInfo.data) {
        let dataCntCheck = true;
        let errorDataCheck = false;
        if (!this.excelUploadInfo.data[0] || this.excelUploadInfo.data[0].length === 0) {
          dataCntCheck = false;
        }
        if (this.$_.findIndex(this.excelUploadInfo.data[0], (item) => { return item.error_message }) > -1) {
          errorDataCheck = true
        }
        if (!dataCntCheck) {
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.', // 업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.
            type: 'warning', // success / info / warning / error
          });
        } else {
          if (errorDataCheck) {
            window.getApp.$emit('CONFIRM', {
              title: '확인',
              message: '에러가 있는 데이터가 존재합니다.\n\r에러 있는 데이터를 제외한 나머지 데이터를 적용하시겠습니까?',
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수  
              confirmCallback: () => {
                this.$emit('closePopup', this.excelUploadInfo.data[0]);
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          } else {
            this.$emit('closePopup', this.excelUploadInfo.data[0], this.excelUploadInfo.columns[0]);
          }
        }
      }
    }
  }
};
</script>
